// extracted by mini-css-extract-plugin
module.exports = {"container":"consent-aware_container__R_Ucr"};